export default __webpack_public_path__ + "static/media/CCRs.eba48851.pdf";